'use client'

import { type FC } from 'react'

import { SearchPageAdBanner } from '../components/SearchPageAdBanner'
import { type SearchPageAdBannerComponentProps } from '../components/SearchPageAdBanner/SearchPageAdBannerTypes'

import {
  SEARCH_PAGE_AD_BANNER_SEARCH_BOTTOM,
  SEARCH_PAGE_AD_BANNER_SEARCH_BOTTOM_DIMENSIONS,
} from './SearchPageAdBannerConfig'

export const SearchPageAdBannerBottom: FC<SearchPageAdBannerComponentProps> = ({
  bannerClasses,
  wrapperComponent,
}) => (
  <SearchPageAdBanner
    bannerClasses={bannerClasses}
    bannerTags={[SEARCH_PAGE_AD_BANNER_SEARCH_BOTTOM]}
    dimensions={SEARCH_PAGE_AD_BANNER_SEARCH_BOTTOM_DIMENSIONS}
    wrapperComponent={wrapperComponent}
  />
)
